import HeroSection from "./components/HeroSection";
import HowItWorksSection from "./components/HowItWorksSection";
import GTAISection from "./components/GTAISection";
import TrustSecuritySection from "./components/TrustSecuritySection";
import CTASection from "../../components/shared/CTASection";

export default function LandingPage() {
  return (
    <>
      <HeroSection />
      <HowItWorksSection />
      <GTAISection />
      <TrustSecuritySection />
      <CTASection
        title="Ready to Connect?"
        subtitle="Join verified businesses worldwide and start building secure partnerships today"
        buttons={[
          {
            text: "Sign Up Free",
            link: "/signup",
            style: "primary",
          },
          {
            text: "Explore Companies",
            link: "/discover",
            style: "secondary",
          },
        ]}
      />
    </>
  );
}
